
import mediaUijs from 'mediaelement/build/mediaelement-and-player';
import mediaUiCss from 'mediaelement/build/mediaelementplayer.css';
import mediaUiJs2 from 'mediaelement/build/mediaelement';

import particleJS from 'particles.js';

export default class CustomFunctions {

  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 実行する
   */
  init() {
    this.infiniteSlider();
    this.textEmphasis();
    this.listItem_business();
    this.audioUiCustom();
    this.floatingWaveMain();
    this.entryButton();
    this.particles();
  }

  /**
   * カスタム関数
   */

  // ループスライダー
  infiniteSlider() {
    const optionInfinite = {
      infinite: true,
      arrows: false,
      swipe: false,
      dots: false,
      variableWidth: true,  // スライド幅の自動計算を無効
      autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      cssEase: "linear",
      pauseOnFocus: false,
      pauseOnHover: false
    }
    const slickInfinite = $('.js-infinite-slider');
    if (slickInfinite) $(slickInfinite).slick(optionInfinite);
  }


  // front > 登録ボタン
  entryButton() {
    let $target = $('.js-float-button');
    let $content = $('.js-float-pop');
    let $closeButton = $('.js-float-close')

    if (!$target && !$content) { return false; }

    // is-slidebar-active
    $target.on('click', function () {
      $('body').addClass('is-fixer')
      $content.addClass('is-active');
    });
    $closeButton.on('click', function () {
      $('body').removeClass('is-fixer')
      $content.removeClass('is-active');
    });
  }
  // 複製して作業
  mycode() {

  }

  // Top offer 点の装飾
  textEmphasis() {
    const target = document.querySelector('.js-emphasis');

    if (!target) return;

    const textArray = target.innerHTML;
    target.innerHTML = "";

    for (let i = 0; i < textArray.length; i++) {

      for (let j = 0; j < textArray[i].length; j++) {
        const span = document.createElement('b');
        span.textContent = textArray[i][j];
        target.appendChild(span);
      }
    }
  }

  // 事業内容 > 具体的な施策・受注プロセス戦略 個数調整
  listItem_business() {
    let $target = $('.js-count-strategy');
    if (!$target) return false;

    let $item = $target.find($('.c-block-strategy__item'));
    let $itemCount = $item.length;

    // 奇数判定
    if ($itemCount % 2 !== 0) {
      $target.addClass('is-item-odd');
    }
  }


  // メディア > audio 
  audioUiCustom() {
    // var player = new MediaElementPlayer('audio-2380-1'); // プレイヤーを初期化
    // player.setSrc('../assets/audio/audio-01.mp3'); // 再生したい音源を設定（保管しているサンプル音源のパスを記載）
    // var player = new MediaElementPlayer('audio-2380-2'); // プレイヤーを初期化
    // player.setSrc('../assets/audio/audio-02.mp3'); // 再生したい音源を設定（保管しているサンプル音源のパスを記載）
    // // player.play(); // 再生実行
  }


  floatingWaveMain() {
    var unit = 100,
      canvasList, // キャンバスの配列
      info = {}, // 全キャンバス共通の描画情報
      colorList; // 各キャンバスの色情報

    /**
     * Init function.
     *
     * Initialize variables and begin the animation.
     */
    function init() {
      info.seconds = 0;
      info.t = 0;
      canvasList = [];
      colorList = [];
      // canvas1個めの色指定
      canvasList.push(document.getElementById("js-floating-wave-main"));
      colorList.push(['#00E2FF', '#00E2FF', '#00E2FF', '#00E2FF', '#00E2FF']);//重ねる波線の色設定



      // 各キャンバスの初期化
      for (var canvasIndex in canvasList) {
        var canvas = canvasList[canvasIndex];
        canvas.width = document.documentElement.clientWidth; // Canvasのwidthをウィンドウの幅に合わせる
        canvas.height = 200;//波の高さ
        canvas.contextCache = canvas.getContext("2d");
      }
      // 共通の更新処理呼び出し
      update();
    }

    function update() {
      for (var canvasIndex in canvasList) {
        var canvas = canvasList[canvasIndex];
        // 各キャンバスの描画
        draw(canvas, colorList[canvasIndex]);
      }
      // 共通の描画情報の更新
      info.seconds = info.seconds + .007;
      info.t = info.seconds * Math.PI;
      // 自身の再起呼び出し
      setTimeout(update, 35);
    }

    /**
     * Draw animation function.
     *
     * This function draws one frame of the animation, waits 20ms, and then calls
     * itself again.
     */
    function draw(canvas, color) {
      // 対象のcanvasのコンテキストを取得
      var context = canvas.contextCache;
      // キャンバスの描画をクリア
      context.clearRect(0, 0, canvas.width, canvas.height);

      //波を描画 drawWave(canvas, color[数字（波の数を0から数えて指定）], 透過, 波の幅のzoom,波の開始位置の遅れ )
      drawWave(canvas, color[0], 0.3, 2, 0);
      drawWave(canvas, color[1], 0.3, 3, 0);
      drawWave(canvas, color[1], 0.3, 4, 1);
      drawWave(canvas, color[1], 0.3, 5, 2);
      drawWave(canvas, color[1], 0.3, 6, 2);
    }

    /**
     * 波を描画
     * drawWave(色, 不透明度, 波の幅のzoom, 波の開始位置の遅れ)
     */
    function drawWave(canvas, color, alpha, zoom, delay) {
      var context = canvas.contextCache;
      context.strokeStyle = color;//線の色
      context.lineWidth = 1;//線の幅
      context.globalAlpha = alpha;
      context.beginPath(); //パスの開始
      drawSine(canvas, info.t / 0.5, zoom, delay);
      context.stroke(); //線
    }

    /**
     * Function to draw sine
     *
     * The sine curve is drawn in 10px segments starting at the origin.
     * drawSine(時間, 波の幅のzoom, 波の開始位置の遅れ)
     */
    function drawSine(canvas, t, zoom, delay) {
      var xAxis = Math.floor(canvas.height / 2);
      var yAxis = 0;
      var context = canvas.contextCache;
      // Set the initial x and y, starting at 0,0 and translating to the origin on
      // the canvas.
      var x = t; //時間を横の位置とする
      var y = Math.sin(x) / zoom;
      context.moveTo(yAxis, unit * y + xAxis); //スタート位置にパスを置く

      // Loop to draw segments (横幅の分、波を描画)
      for (var i = yAxis; i <= canvas.width + 1; i += 1) {
        x = t + (-yAxis + i) / unit / zoom;
        y = Math.sin(x - delay) / 3;
        context.lineTo(i, unit * y + xAxis);
      }
    }

    var items = $("#js-floating-wave-main");
    if (items.length <= 0) {
      return false;
    } else {
      init();
    }

  };


  // 複製して作業
  particles() {
    /* particlesJS.load(@dom-id, @path-json, @callback (optional)); */
    if ($("#particles-js").length != 0) {
      particlesJS.load('particles-js', 'wp-content/themes/marketersbrain-html/dist/assets/js/particlesjs-config.json');
    }

    if ($("#particles-c-js").length != 0) {
      particlesJS.load('particles-c-js', 'wp-content/themes/marketersbrain-html/dist/assets/js/particlesjs-config-white.json');
    }

    if ($("#particles-js-co").length != 0) {
      particlesJS.load('particles-js-co', 'wp-content/themes/marketersbrain-html/dist/assets/js/particlesjs-config-co.json');
    }

  }


}




